export default __webpack_public_path__ + "static/media/enterprise.39a2ef56.svg";